import type { ContentContainer } from "../core/types";
import { Logger } from "../core/Logger";
import type { ITrackingService } from "./ITrackingService";

export class TrackingOrchestrator implements ITrackingService {

    private children: ITrackingService[];

constructor(...children: ITrackingService[]) {
    this.children = children;
}

    initialize(): void {
        this.children.forEach((child) => {
            try {
                child.initialize();
            } catch (error) {
                Logger.error('[TrackingOrchestrator] initialize failed:', error);
            }
        })
    }

    trackOpen(container: ContentContainer): void {
        this.children.forEach((child) => {
            try {
                child.trackOpen(container);
            } catch (error) {
                Logger.error('[TrackingOrchestrator] trackOpen failed:', error);
            }
        })
    }

    trackClose(container: ContentContainer): void {
        this.children.forEach((child) => {
            try {
                child.trackClose(container);
            }
            catch (error) {
                Logger.error('[TrackingOrchestrator] trackClose failed:', error)
            }
        })
    }

    trackFieldInteraction(container: ContentContainer, fieldName: string, fieldValue?: string): void {
        this.children.forEach((child) => {
            try {
                child.trackFieldInteraction(container, fieldName, fieldValue);
            }
            catch (error) {
                Logger.error('[TrackingOrchestrator] trackFieldInteraction failed:', error);
            }
        })
    }

    trackSubmit(container: ContentContainer): void {
        this.children.forEach((child) => {
            try {
                child.trackSubmit(container);
            }
            catch (error) {
                Logger.error('[TrackingOrchestrator] trackSubmit failed:', error);
            }
        })
    }

    trackContinueToCreditApp(container: ContentContainer): void {
        this.children.forEach((child) => {
            try {
                child.trackContinueToCreditApp(container);
            }
            catch (error) {
                Logger.error('[TrackingOrchestrator] trackContinueToCreditApp failed:', error);
            }
        })
    }
}
